import {useEffect, useState } from "react"
import {api_post, api_get, api_put, api_delete} from './api_client'
import { getCookie } from "../lib"

function useUser() {

  const [userData, setUserData] = useState({
    userName:'',
    firstName:'',
    lastName:'',
    address:'',
    contactNo:'',
    password:'',
    rePassword:'',
    companyName:'',
    resetCode:''
  })

  useEffect(() =>{
  },[])

/*   const login1 = () => api_post({ url: "user/login", data: userData })
  const register1 = () => api_post({ url: "user/register", data: userData })
  const reset1 = () => api_post({ url: "user/reset", data: userData })
  const resetPassword1 = () => api_post({ url: "user/resetpassword", data: userData })
  const login_secret1 = (secret) => api_get({ url: "user/login_secret",queryParam:{secret: secret}})
 */
  const login = () => api_post({ url: "user/login", data: userData }) 
  const register = () => api_post({ url: "user/register", data: userData })
  const reset = () => api_post({ url: "user/reset", data: userData })
  const resetPassword = () => api_post({ url: "user/resetpassword", data: userData })
  const login_secret = (secret) => api_get({ url: "user/login_secret",queryParam:{secret: secret}})
  const allowedLogins = () => api_get({ url: "user/allowed_logins"})
  const getUser = (user_id) => api_get({ url: "user",queryParam:{user_id:user_id}}) 
  const addUser = (_data) => api_post({ url: "user",data:_data}) 
  const updateUser = (_data) => api_put({ url: "user",data:_data}) 
  const deleteUser = (_data) => api_delete({..._data, url: "user"}) 

   
  return {user:{login , register, reset , resetPassword, login_secret}, userData, setUserData,allowedLogins, getUser, addUser, updateUser, deleteUser}
}

export {useUser}


